module.exports = __webpack_public_path__ + "static/img/photo4.beb07ff8.jpg";